<template>
	<div class="col-md-12 col-sm-12 col-xs-12">
		<div class="pay-qr trans-qr">
			<div class="row">
				<div>
					<div class="qr-img in-pc">
						<div :class="'ic_' + iconName"></div>
						<p class="img"><img :src="qrsrc" @load="onImageLoad" class="img-responsive"></p>
						<p v-show="loaded"><img :src="tips" class="img-responsive"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'PayQr',
	data: () => ({
		'qrsrc': null,
		'tips': null,
		'timer': null,
		'counting': 0,
		'loaded': false,
		'iconName': null
	}),
	computed: {
		...mapGetters({
			mweb: 'getMweb'
		})
	},
	components: {
	},
	created: function () {
		this.tips = ''
		this.iconName = ''
	},
	mounted: function () {
		this.setPageTitle('订单支付')
		console.log(this.mweb)
		let name = this.$route.params.name
		if (name === 'weixin') {
			this.tips = '/static/img/qr_weixin_tips.png'
			this.qrsrc = this.mweb.qrImageUrl
			this.iconName = 'weixin'
		} else if (name === 'alipay') {
			this.tips = '/static/img/qr_alipay_tips.png'
			this.qrsrc = this.mweb.qrImageUrl
			this.iconName = 'alipay'
		} else {
			this.$router.go(-1)
		}
		this.rollingPayStatus()
	},
	beforeDestroy: function () {
		if (this.timer) {
			clearTimeout(this.timer)
			this.timer = null
		}
	},
	methods: {
		onImageLoad () {
			this.loaded = true
		},
		rollingPayStatus () {
			if (this.timer) {
				clearTimeout(this.timer)
				this.timer = null
			}
			if (this.counting >= 300) {
				// 5分钟
				this.toast('支付超时')
				window.location.href = '?#/pay/online/' + this.$route.params.id
			} else {
				let self = this
				this.timer = setTimeout(function () {
					self.checkPayStatus(true)
				}, 2000)
				this.counting += 2
			}
		},
		checkPayStatus (rolling) {
			let url = '/api/payments/status/' + this.mweb.traceNo
			this.$http.get(url).then(response => {
				// console.log(response)
				var rs = response.body
				if (rs.code === 0) {
					if (rs.data.status === 1) {
						// window.location.href = '#/orders/pay/success/' + this.$route.params.id
						this.$store.dispatch('setOrder', {'order': rs.data.order})
						if (rs.data.full_pay === true) {
							// window.location.href = '#/orders/pay/success/' + this.$route.params.id
							window.location.href = '#/orders/verify/' + this.$route.params.id
						} else {
							this.$router.go(-1)
						}
					} else if (rs.data.status === 2) {
						this.toast('支付失败，请重新支付')
					} else {
						if (rolling) {
							this.rollingPayStatus()
						} else {
							this.toast('支付超时')
							window.location.href = '?/pay/online/' + this.$route.params.id
						}
					}
				} else {
					this.handleHttpError(response)
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PayQr.vue?2db9bde2